/** @format */

const theme = {
  // Color
  accent: "rgb(57, 220, 206)",
  primary: "rgb(90, 202, 255)",
  primarySol: "rgb(77, 135, 255)",
  primaryTxt: "rgb(39, 109, 255)",
  mono0: "rgb(34, 34, 34)",
  monoDivider: "rgb(225, 225, 225)",
  monoDisabled: "rgb(228, 228, 228)",
  mono50: "rgb(138, 138, 138)",
  monoBg: "rgb(246, 246, 246)",
  monoDim: "rgb(194, 194, 194)",
  mono100: "#FFF",
  success: "rgb(57, 220, 156)",
  danger: "rgb(247, 68, 68)",
  aquaMarine: "#39dcce",
  banner1: "#E7F6FE",
  banner2: "#E9E9E9",
  banner3: "#F6EBDC",
  banner4: "rgb(236, 234, 255)",
  bg1: "rgb(229, 242, 255)",

  gray: "#e4e4e4",

  // Font
  font: '"Noto Sans KR", sans-serif',
  demiLight: 300,
  regular: 400,
  medium: 500,
  bold: 700,

  // Layout
  gap: 20,

  t1: {
    fontSize: "2.6rem",
    lineHeight: "3.6rem",
    letterSpacing: "-0.02rem",
  },

  t2: {
    fontSize: "2.2rem",
    lineHeight: "3.2rem",
  },

  t3: {
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    letterSpacing: "-0.04rem",
  },
  text: {
    fontSize: "1.6rem",
    lineHeight: "2.8rem",
    letterSpacing: "-0.02rem",
    fontWeight: 350,
  },
  sText: {
    fontSize: "1.4rem",
    lineHeight: "2.2rem",
    letterSpacing: "-0.02rem",
    fontWeight: 350,
  },
};

export default theme;
export type ThemeType = typeof theme;
